import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const getUnselectedFields = (selectedColumnObjs, fields) => {
    if (!selectedColumnObjs || !fields) {
        return [];
    }
    return fields.filter(field => !selectedColumnObjs.some(obj => obj.field === field));
}

const FieldEditor = ({ tablePoppedUp, selectedColumnObjs, setSelectedColumnObjs, customTableMetaSetting, setCustomTableMetaSetting }) => {
    const table = tablePoppedUp;
    const fields = table.columns.map(c => c.field).flat();
    const [selectedField, setSelectedField] = useState('');
    const [unselectedFields, setUnselectedFields] = useState(getUnselectedFields(selectedColumnObjs, fields));


    let data_type_mapping = {
        "datetime": ["datetime", "timestamp", "varchar(50)", "char(50)", "text"],
        "varchar(50)": ["varchar(50)", "char(50)", "text"],
        "int": ["int", "varchar(50)", "char(50)", "smallint", "mediumint", "bigint", "float", "double"],
        "text": ["text", "varchar(50)", "char(50)", "tinytext", "mediumtext", "longtext"],
    }


    const handleAddColumn = () => {

        if (selectedField !== '') {

            const field_exists = selectedColumnObjs.some(obj => obj.field === selectedField);

            if (!field_exists) { // Corrected the logic to check if the object doesn't exist
                // get type of the selected field, this is from the table object
                let selectedFieldType = table.columns.find(column => column.field === selectedField).type;
                let newSelectedColumnObjs = [...selectedColumnObjs, { field: selectedField, columnName: selectedField, type:selectedFieldType, targetType: selectedFieldType }];
                setSelectedColumnObjs(newSelectedColumnObjs);
                setUnselectedFields(getUnselectedFields(newSelectedColumnObjs, fields));
                toast.success(`Column ${selectedField} added successfully`, { duration: 2000 });

            } else {
                toast.error("Column already exists", { duration: 2000 });
            }

        } else {
            // console.log("Selected field or column name is empty.");
        }
        setSelectedField('');
    };

    const handleRemoveColumn = (index) => {
        const updatedColumns = [...selectedColumnObjs];
        updatedColumns.splice(index, 1);
        setSelectedColumnObjs(updatedColumns);
        setUnselectedFields(getUnselectedFields(updatedColumns, fields));
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", color: "white" }}>
            <div>
                Mapping table:
                <input type='text' 
                    defaultValue={customTableMetaSetting.targetName}
                    onChange={(e) => setCustomTableMetaSetting({ ...customTableMetaSetting, targetName: e.target.value })}
                />
                <div>
                    <input type='checkbox'
                        id='createIfNonExist'
                        defaultChecked={customTableMetaSetting.createIfNonExist}
                        onChange={(e) => setCustomTableMetaSetting({ ...customTableMetaSetting, createIfNonExist: e.target.checked })}
                    />
                    <label htmlFor='createIfNonExist'>Create table if it doesn't exist</label>
                </div>
            </div>
            <div>
                {/* <ColoredScrollbars style={{ height: "165px", width: "400px" }}> */}
                    {selectedColumnObjs && selectedColumnObjs.length === 0
                        ? <p style={{ textAlign: "center" }}>No columns selected</p>
                        : (<table style={{ width: "400px", textAlign: "center", color: "white" }}>
                            <thead style={{ fontSize: "smaller" }}>
                                <tr>
                                    <th style={{ flex: 1 }}>Existing Field</th>
                                    <th style={{ flex: 1 }}>Name As</th>
                                    <th style={{ flex: 1 }}>Data Type</th>
                                    <th style={{ flex: 1 }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedColumnObjs && selectedColumnObjs.map((column, index) => (
                                    <tr key={index}>
                                        <td>{column.field}</td>
                                        <td>
                                            <input 
                                                value={column.columnName} 
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    
                                                    // Allow only letters, numbers, and underscores
                                                    const regex = /^[a-zA-Z0-9_]*$/; 
                                                    
                                                    if (regex.test(inputValue)) {
                                                    let temp = [...selectedColumnObjs];
                                                    temp[index].columnName = inputValue;
                                                    setSelectedColumnObjs(temp);
                                                    } else {
                                                    toast.error("Invalid input! Only letters, numbers, and underscores are allowed.");
                                                    }
                                                }} 
                                            />
                                            {
                                                column.columnName.trim() === "" && <PriorityHighIcon sx={{color:"yellow"}}/>
                                            }
                                        </td>
                                        <td>
                                            <select  value={column.targetType} onChange={(e) => {
                                                let temp = [...selectedColumnObjs];
                                                temp[index].targetType = e.target.value;
                                                setSelectedColumnObjs(temp);
                                            }}>
                                                {Array.isArray(data_type_mapping[column.type])
                                                    ? data_type_mapping[column.type].map((type, index) => (
                                                        <option key={index} value={type}>{type}</option>
                                                    ))
                                                    : (console.error(`Invalid column type: ${column.type}`), null)}
                                            </select>
                                        </td>
                                        <td style={{display:"flex", justifyContent:"center"}}>
                                            <div className="icon-container" onClick={() => handleRemoveColumn(index)}>
                                                <DeleteOutlineIcon/>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>)}
                {/* </ColoredScrollbars> */}
            </div>
            {
                selectedColumnObjs && selectedColumnObjs.length < fields.length && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <select 
                            value={selectedField} onChange={(e) => setSelectedField(e.target.value)}
                            style={{textAlign: "center", height: "40px", borderRadius: "8px", marginRight: "3px"}}
                            >
                            <option value="">Add more columns</option>
                            {unselectedFields.map((obj, index) => (
                                <option key={index} value={obj.field}>{obj}</option>
                            ))}
                        </select>
                        {selectedField && (
                            <div style={{ display: "flex" }}>
                                <button 
                                    style={{ all: "unset", cursor: "pointer" }} 
                                    onClick={handleAddColumn}
                                >
                                    Add
                                </button>
                            </div>
                        )}
                    </div>
                )
            }
        </div>
    );
};

export default FieldEditor;